import React from "react";
import girl from "./Images/girl.png";
import money from "./Images/money.png";

import "./css/Home.css";
const Home = () => {
  return (
    <>
      <div className="md:mt-24 md:mb-32">
        <div className="md:flex w-full">
          <div className="Text-section md:w-1/2">
            <div className="text1">
              Empowering Your Financial
              <br />
              Future.
              <div className="sub-text">
                Unlock Growth and Financial Stability with our mega
                <br />
                Deposit package = Your path to prosperity!
                <br />
                <br />
                <br />
                <button className="btn">Get Started</button>
              </div>
            </div>
          </div>
          <div className="picture md:relative md:flex md:w-1/2">
            <div className="money-img md:absolute md:left-28 md:flex md:mt-28">
              <img src={money} alt="Money" className="md:w-[70%]" />
            </div>

            <div className="girl-img md:absolute md:right-0 md:top-[46%] ">
              <img src={girl} alt="Girl" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
